import { Model } from "vue-mc";

export class Archivos extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , tipo: ""
      , subtipo: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , tipo: (tipo) => tipo
      , subtipo: (subtipo) => subtipo
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/models/generales/archivos.js